var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"maintenance-banner mb-3",attrs:{"type":"warning","text":"","dense":"","dismissible":"","icon":"mdi-wrench-outline"},on:{"input":_vm.onInput}},[_c('span',{staticClass:"maintenance-text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }